import React from 'react'
import { WidgetId } from 'features/types'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { SocialWebStreamWidget } from 'schemas/SocialWebStreamWidgetSchema'
import CountType from 'enums/CountType'
import DocumentSoundbiteSearchEffect from '../share/searches/DocumentSoundbiteSearchEffect'
import SentenceSoundbiteSearchEffect from '../share/searches/SentenceSoundbiteSearchEffect'

const SoundbiteRunSearchEffect = ({
  widgetId,
  fingerprintIndex,
  children
}: {
  widgetId: WidgetId
  fingerprintIndex: number
  children: React.ReactElement
}) => {
  const { countType } = useDashboardWidgetSetting<SocialWebStreamWidget>(widgetId)

  return countType === CountType.POSTS ? (
    <DocumentSoundbiteSearchEffect widgetId={widgetId} fingerprintIndex={fingerprintIndex}>
      {children}
    </DocumentSoundbiteSearchEffect>
  ) : (
    <SentenceSoundbiteSearchEffect widgetId={widgetId} fingerprintIndex={fingerprintIndex}>
      {children}
    </SentenceSoundbiteSearchEffect>
  )
}

export default SoundbiteRunSearchEffect
